import { SET_POPUP, SET_CHILD_POPUP } from './constants';

const initialState = {
  popup: false,
  childPopup: false,
};

// eslint-disable-next-line default-param-last
export function popup(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case SET_POPUP: {
      // reset childPopup
      return { ...initialState, popup: payload };
    }
    case SET_CHILD_POPUP: {
      return { ...state, childPopup: payload };
    }
    default:
      return state;
  }
}
